module.exports = __webpack_public_path__ + "static/media/head.85e5c57a.png";